
import Vue from 'vue';
import { Component, Prop } from 'nuxt-property-decorator';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';
import type { BodyScrollOptions } from 'body-scroll-lock';
import TocContent from '../toc/panel/TocContent.vue';
import TocBottom from '../toc/panel/TocBottom.vue';
import CloseBtn from '../side-panel/CloseBtn.vue';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';
import HeaderOffsetSpacer from '@/components/ui/HeaderOffsetSpacer.vue';

@Component({
  components: {
    HeaderOffsetSpacer,
    CloseBtn,
    TocBottom,
    TocContent
  }
})
export default class LeftDrawer extends Vue {
  @Prop({ type: Boolean, default: false })
  private readonly open: boolean;

  drawerOpen: boolean = this.open;
  bodyScrollOptions: BodyScrollOptions = {
    reserveScrollBarGap: true
  };

  mounted() {
    if (this.$vuetify.breakpoint.smAndDown) {
      disableBodyScroll(this.$refs.drawerContent, this.bodyScrollOptions);
    } else {
      enableBodyScroll(this.$refs.drawerContent);
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  closeDrawer(): void {
    SidePanelStore.leftPanelIsOpen = false;
  }
}
